<div class="disclaimer">
    {{ resourceKey | resource }}
</div>